import { api } from "@/api"
import type { MerchantGroupUser } from "./types"
import { queryClient } from "@/queryClient"

export const deactivateMerchantGroupUser = async (
  userId: MerchantGroupUser["id"]
) => {
  await api.post(
    `/merchant-group/users/${userId}/deactivate/`,
    { isMerchantGroup: true }
  )
  queryClient.invalidateQueries([
    BASE_MERCHANT_GROUP_USERS_QUERY_KEY,
  ])
}
